import clsx from 'clsx'
import type { FunctionComponent } from 'react'
import { Hidden } from '../shared/Hidden'
import { LoaderDailyDose } from '../shared/LoaderDailyDose'
import style from './ProductBanner.module.sass'
type LoaderProductBannerProps = {
	isHighlighted?: boolean
}

export const LoaderProductBanner: FunctionComponent<LoaderProductBannerProps> = ({ isHighlighted = false }) => {
	return (
		<div
			className={clsx(
				style.articleWrapper,
				isHighlighted && style.articleWrapperHighlighted && style.articleWrapperHighlightedLoader,
			)}
		>
			<div className={style.article}>
				<div className={clsx(style.leftContent, style.leftContentLoader)}>
					<div className={style.imageWrapper}>
						<div className={clsx(style.loading, style.loadingImage)} />
					</div>
					<Hidden breakpoint="mobileDown">
						<div className={style.buttonCompareWrapper}>
							<div className={clsx(style.loading, style.loadingPlainButton)} />
						</div>
					</Hidden>
				</div>
				<div className={style.body}>
					<Hidden breakpoint="mobileDown">
						<div className={style.title}>
							<div className={clsx(style.loading, style.loadingTitle)} />
						</div>
						<div className={style.paragraph}>
							<div className={clsx(style.loading, style.loadingSubtitle)} />
						</div>
					</Hidden>
					<div className={style.additionalInfoWrapper}>
						<div className={clsx(style.loading, style.loadingAdditional)} />
					</div>
				</div>
				<div className={style.rightContent}>
					<div className={clsx(style.loading, style.loadingRating)} />
					<LoaderDailyDose />
					<div className={style.buttonWrapper}>
						<div className={clsx(style.loading, style.loadingButton)} />
					</div>
				</div>
			</div>
			{isHighlighted && (
				<div className={clsx(style.infoBarGroup, style.infoBarGroupLoading)}>
					<div className={clsx(style.loading, style.loadingBar)} />
					<div className={clsx(style.loading, style.loadingBar)} />
				</div>
			)}
		</div>
	)
}
